"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var images_1 = require("../../../../images");
var sandwich_ids_1 = require("../../../../sandwich-ids");
var Image = function (_a) {
    var meterStatus = _a.meterStatus;
    if (meterStatus.status === 'ok') {
        return (react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.status.ok },
            react_1.default.createElement(images_1.MeterTickImage, null)));
    }
    else if (meterStatus.status === 'warning' &&
        meterStatus.meterType === 'smart') {
        return (react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.status.warning.smart },
            react_1.default.createElement(images_1.MeterWarningImage, null)));
    }
    else if (meterStatus.status === 'due') {
        // only trad have 'due' status
        return (react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.status.due },
            react_1.default.createElement(images_1.ClockArrowImage, null)));
    }
    else if (meterStatus.status === 'warning' &&
        meterStatus.meterType === 'trad') {
        return (react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.status.warning.traditional },
            react_1.default.createElement(images_1.ClockWarningImage, null)));
    }
    else {
        return null;
    }
};
exports.Image = Image;
